export default "__VITE_ASSET__5KC1YoE9__"